import { IncidentSeverity } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const incidentSeverityDetails = (severity: IncidentSeverity): [string, string, string] => {
  switch (severity) {
    case IncidentSeverity.Low:
      return [
        'yellow',
        'Low',
        'Minor issue with minimal impact, e.g. Small tripping hazard or injury not requiring first aid',
      ];
    case IncidentSeverity.Medium:
      return [
        'orange',
        'Medium',
        'Significant problem or impact needing timely but not urgent action, e.g. Injury requiring first aid or damage to property',
      ];
    case IncidentSeverity.High:
      return [
        'red',
        'High',
        'Critical issue requiring immediate attention and resolution, e.g. Severe injury requiring hospitalisation, death or environmental disaster management',
      ];
  }
};

interface Props extends ChakraV3.TagRootProps {
  severity: IncidentSeverity;
}

export const IncidentSeverityTag = (props: Props) => {
  const { severity, ...rest } = props;

  const [color, name, description] = incidentSeverityDetails(severity);

  return (
    <ChakraV3.Tooltip content={description}>
      <ChakraV3.Tag colorPalette={color} {...rest}>
        {name}
      </ChakraV3.Tag>
    </ChakraV3.Tooltip>
  );
};
